import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import MeetingBookingApi from "../../api/MeetingBookingApi";

function PublicBooking() {
  const navigate = useNavigate();

  const { slug } = useParams();

  const [loading, setLoading] = useState(false);

  const [user, setUser] = useState(null);

  const [date, setDate] = useState("");

  const [slots, setSlots] = useState([]);

  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    meetingTime: "",
  });

  useEffect(() => {
    loadUser();
  }, []);

  const loadUser = async () => {
    try {
      const res = await MeetingBookingApi.getUser(slug);

      if (res.code === 200) {
        setUser(res.data);
      }
    } catch (err) {
      alert(err.message);
    }
  };

  const loadSlots = async (selectedDate) => {
    setDate(selectedDate);

    if (!selectedDate) return;

    try {
      const res = await MeetingBookingApi.getSlots(slug, selectedDate);

      if (res.code === 200) {
        setSlots(res.data);
      }
    } catch (err) {
      alert(err.message);
    }
  };

  const submit = async () => {
    if (!form.name) {
      return alert("Enter Name");
    }

    if (!form.email) {
      return alert("Enter Email");
    }

    if (!form.phone) {
      return alert("Enter Phone");
    }

    if (!date) {
      return alert("Select Date");
    }

    if (!form.meetingTime) {
      return alert("Select Time");
    }

    try {
      setLoading(true);

      const res = await MeetingBookingApi.book({
        ...form,

        meetingDate: date,

        slug,
      });

      if (res.code === 200) {
        navigate(
          "/booking-success",

          {
            state: {
              meetingDate: date,

              meetingTime: form.meetingTime,

              meetLink: res.data.meetLink,
            },
          },
        );
      }
    } catch (err) {
      alert(err.message);
    }

    setLoading(false);
  };

  return (
    <div className="container mt-5">
      <div className="card shadow">
        <div className="card-body">
          <h2>Book Meeting</h2>

          <p>With {user?.name}</p>

          <input
            className="form-control mb-3"
            placeholder="Full Name"
            value={form.name}
            onChange={(e) =>
              setForm({
                ...form,
                name: e.target.value,
              })
            }
          />

          <input
            className="form-control mb-3"
            placeholder="Email"
            value={form.email}
            onChange={(e) =>
              setForm({
                ...form,
                email: e.target.value,
              })
            }
          />

          <input
            className="form-control mb-3"
            placeholder="Phone"
            value={form.phone}
            onChange={(e) =>
              setForm({
                ...form,
                phone: e.target.value,
              })
            }
          />

          <input
            type="date"
            className="form-control mb-3"
            value={date}
            onChange={(e) => loadSlots(e.target.value)}
          />

          <select
            className="form-control mb-4"
            value={form.meetingTime}
            onChange={(e) =>
              setForm({
                ...form,
                meetingTime: e.target.value,
              })
            }
          >
            <option value="">Select Time</option>

            {slots.map((slot) => (
              <option key={slot} value={slot}>
                {slot}
              </option>
            ))}
          </select>

          <button
            disabled={loading}
            onClick={submit}
            className="btn btn-primary w-100"
          >
            {loading ? "Booking..." : "Book Meeting"}
          </button>
        </div>
      </div>
    </div>
  );
}

export default PublicBooking;
